import { render, staticRenderFns } from "./AccountStatusTab.vue?vue&type=template&id=118ea442"
import script from "./AccountStatusTab.vue?vue&type=script&lang=js"
export * from "./AccountStatusTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports